module.exports = __webpack_public_path__ + "img/10.05410cc9.jpg";